export enum AggregationEngine {
  NONLINEAR = 'Axioma',
  LINEAR = 'PremiaLab',
  STRATEGY = 'Backend',
}

export enum AggregationProvider {
  AXIOMA = 'Axioma',
  MSCI = 'MSCI',
}

export enum GroupName {
  ASSET = 'Asset',
  TRANSITIVE = 'Transitive',
  HISTORICAL = 'Historical',
  EXPOSURE = 'Exposure',
  VaR = 'VaR',
  SENSITIVITY = 'Sensitivity',
  LADDER = 'Ladder',
}

export enum FxFormulaConstants {
  NO_CONVERSION = '0 - No Conversion',
  DIRECT_CONVERSION = '1 - Direct Conversion',
  FX_DELTAS = '2 - FX Deltas',
  FX_STRESS_TEST = '3 - FX Stress Test',
  FX_VOL_STRESS_TEST = '4 - FX Vol Stress Test',
  FX_USD_CCY_STRESS_TEST = '5 - FX usdCCY Stress Test',
}

export enum UnitConstants {
  REPORT_CCY = 'Report ccy',
  HOLDING_CCY = 'Holding ccy',
  PERCENTAGE = '%',
  PERCENTAGE_YEARS = '%/Year',
  DATE = 'Date',
  TIMESTAMP = 'Timestamp',
  YEARS = 'Years',
  TEXT = 'Text',
}
